import { render } from "./FDUnderline.vue?vue&type=template&id=bb78dc80"
import script from "./FDUnderline.vue?vue&type=script&lang=js"
export * from "./FDUnderline.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__